<template>
    <div id="ImportTotalYoYLast12Months" :style="{ height: '100%' }"></div>
</template>
<script>
import {  lsdRegionTradeStatIndex } from '../../../../api/home.js';

import { buildDynamicCompareData, formatNumber } from '@/utils/tools.js'
import { arrData } from '@/utils/data.js'
export default {
    name: "",
    components: {},
    props: ['intervalRefreshDate'],

    data() {
        return {
            timer: null,
            arrData: [],
            dataItem2: {},
            dataItem: {}

        };
    },
    watch: {},
    computed: {},
    methods: {
        async initData() {
            // 获取当前月份 YYYY-MM
            const now = new Date();
            const endYear = now.getFullYear();
            const endMonth = String(now.getMonth() + 1).padStart(2, '0');
            const dateEnd = `${endYear}-${endMonth}`;

            // 往前推 11 个月（总共为 12 个月）
            const startDate = new Date(endYear, now.getMonth() - 34, 1);
            const startYear = startDate.getFullYear();
            const startMonth = String(startDate.getMonth() + 1).padStart(2, '0');
            const dateStart = `${startYear}-${startMonth}`;

            try {
                const res = await lsdRegionTradeStatIndex({
                    queryType: 'CUSTOM_RANGE',
                    dateStart,
                    dateEnd,
                });
                this.arrData = res.data;
                await this.drawLine();
            } catch (err) {
            }
        },
        buildDynamicCompareData,

        async drawLine() {
            // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
            let myChart = this.$echarts.init(document.getElementById('ImportTotalYoYLast12Months'))
            // 绘制图表
            const data = this.buildDynamicCompareData(this.arrData)
            this.dataItem2 = data.dataItem2;
            this.dataItem = data.dataItem;

            // 去年（示例数据）
            // var zzx1 = [777, 5665, 5665, 5665, 5656, 5656, 5656, 5665, 5656, 5656, 6565, 5665];

            // // 今年（示例数据）
            // var wgx1 = [2323, 2323, 2323, 6231, 2323, 2323, 2323, 3443, 343, 3433, 3434, 3444];


            // 更具wgx1 的length  拼接月份

            let zzx1 = [], wgx1 = [];
            zzx1 = data.importValue.last; //去年
            wgx1 = data.importValue.current; //当年
            // let xAxisData = Array.from({ length: wgx1.length }, (_, i) => `${i + 1}月`);
            let xAxisData = data.xAxisData;



            var zx = zzx1.map((item) => 100 - item);
            var wg = wgx1.map((item) => 100 - item);
            var barWidth = 10;
            // 计算总数
            var option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: { type: "shadow" },

                    formatter: (e) => {
                        // e[0] 或 e[1] 任意有一个都能拿到 index
                        const index = e[0].dataIndex;

                        // 从 dataItem2 中读取同比（这里你要的是进口同比，所以取 importYoyChange）
                        const last = this.dataItem.last[index];
                        const current = this.dataItem.current[index];
                        // 使用接口原始值，而不是自己算
                        const percent = current.importYoyChange || 0;
                        const symbol = percent >= 0 ? '↑' : '↓';
                        const color = percent >= 0 ? '#FF5555' : '#53d78c';

                        return `
                        ${current.year}年${current.month}月<br/>
                        去年：${formatNumber(e[0].value)}<br/>
                        当年：${formatNumber(e[1].value)}<br/>
                        <span style="color:${color};font-weight:bold;">${symbol} ${Math.abs(percent)}%</span>
                         `;
                    }
                    // formatter: function (e) {
                    //     // 找出去年和今年的数据
                    //     const lastYear = e.find(item => item.seriesName === "去年");
                    //     const thisYear = e.find(item => item.seriesName === "当年");


                    //     let percentText = '';
                    //     if (lastYear && thisYear) {
                    //         const diff = thisYear.value - lastYear.value;
                    //         // const percent = lastYear.value !== 0 ? ((diff / lastYear.value) * 100).toFixed(2) : 0;
                    //         const percent = lastYear.value !== 0
                    //             ? Math.round((diff / lastYear.value) * 100) // 四舍五入取整
                    //             : 0;
                    //         const symbol = percent >= 0 ? '↑' : '↓';
                    //         const color = percent >= 0 ? '#FF5555' : '#53d78c';
                    //         // percentText = `<br><span style="color:${color};font-weight:bold;">${symbol} ${Math.abs(percent)}%</span>`;
                    //         percentText = `<br><span style="color:${color};font-weight:bold;">${symbol} ${Math.abs(percent)}%</span>`;

                    //     }

                    //     let str =
                    //         e[6].axisValue + "<br>" +
                    //         "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:" +
                    //         e[6].color.colorStops[0].color +
                    //         ";'></span>" +
                    //         e[6].seriesName + " : " + e[6].value + "<br>" +
                    //         "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:" +
                    //         e[8].color.colorStops[0].color +
                    //         ";'></span>" +
                    //         e[8].seriesName + " : " + e[8].value +
                    //         percentText; // 加上变化百分比显示

                    //     return str;
                    // },
                },

                grid: { left: "10", right: "10", bottom: "4%", top: "16%", containLabel: true },
                legend: {
                    show: false,
                    data: ["去年", "当年"],
                    top: 1,
                    textStyle: { color: "#00ffff", fontSize: 14 },
                    itemWidth: 12,
                    itemHeight: 10,
                    itemGap: 35,
                    selectedMode: true,
                },
                xAxis: {
                    type: "category",
                    // data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
                    data: xAxisData,
                    axisLine: { lineStyle: { color: "#15205B" } },
                    axisTick: { show: false },
                    axisLabel: { color: "#FFFFFF", interval: 0, margin: 15, fontSize: 10 },
                },
                yAxis: {
                    min: 0,
                    max: function (value) {
                        // value.max 是 series 数据的最大值
                        return value.max * 1.1; // 留 10% 空间
                    },
                    type: "value",
                    axisLine: { lineStyle: { color: "#15205B" } },
                    splitLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: {
                        formatter: function (value) {
                            return Math.round(value); // 四舍五入显示整数
                        },
                        color: "#c9c9c9",
                        fontSize: 10
                    }
                },
                series: [
                    // 去年值中间正方形
                    { type: "pictorialBar", symbol: "diamond", symbolSize: [barWidth, 5], symbolOffset: [-5.9, -2], symbolPosition: "end", z: 12, color: "#8bffdd", data: zzx1 },
                    // 今年值中间正方形
                    { type: "pictorialBar", symbol: "diamond", symbolSize: [barWidth, 5], symbolOffset: [6, -2], symbolPosition: "end", z: 12, color: "#1BCC98", data: wgx1 },
                    // 去年值底部正方形
                    { type: "pictorialBar", symbol: "diamond", symbolSize: [barWidth, 5], symbolOffset: [-6, 2], z: 12, color: "#161D6E", data: zzx1 },
                    // 今年值底部正方形
                    { type: "pictorialBar", symbol: "diamond", symbolSize: [barWidth, 5], symbolOffset: [6, 2], color: "#151D6E", z: 12, data: wgx1 },
                    // 去年值上部正方形
                    { type: "pictorialBar", symbol: "diamond", symbolSize: [barWidth, 5], symbolOffset: [-6, -2], z: 12, color: "#283190", symbolPosition: "end", data: Array(12).fill(100) },
                    // 今年值上部正方形
                    { type: "pictorialBar", symbol: "diamond", symbolSize: [barWidth, 5], symbolOffset: [6, -2], color: "#283190", symbolPosition: "end", data: Array(12).fill(100) },
                    // 去年值进度柱子
                    {
                        name: "去年", type: "bar", barWidth: barWidth, stack: "1", itemStyle:
                        {
                            // color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: "#2863D2" },
                            // { offset: 1, color: "#161D6E" }]),

                            color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                { offset: 0, color: "rgba(1,169,222,0.2)" },
                                { offset: 1, color: "#00BCBC" },
                            ]),
                            opacity: 0.7
                        },
                        label: {
                            show: false, position: ["-10", "-18"],
                            color: "#00f8ff", fontSize: 12
                        }, data: zzx1
                    },
                    // 去年值底部柱子
                    { data: zx, type: "bar", barWidth: barWidth, stack: "1", zlevel: -1, itemStyle: { color: "#182075", opacity: 0.7 } },
                    // 今年值进度柱子
                    {
                        name: "当年", type: "bar", barWidth: barWidth, stack: "2",
                        itemStyle: {
                            // color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: "#19958B" }, { offset: 1, color: "#151B6F" }]),
                            color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                { offset: 0, color: "rgba(0,88,255,0.2)" },
                                { offset: 1, color: "#0093DD" },
                            ]),

                            opacity: 0.7
                        }, label: { show: false, position: ["10", "-18"], color: "#00f8ff", fontSize: 12 }, data: wgx1
                    },
                    // 今年值底部柱子
                    { data: wg, type: "bar", barWidth: barWidth, stack: "2", zlevel: -1, itemStyle: { color: "#182075", opacity: 0.7 } },


                    {
                        type: 'custom',
                        name: '',
                        data: zzx1.map((v, i) => ({
                            value: [i, Math.max(zzx1[i], wgx1[i]) + 8] // 只存坐标
                        })),

                        renderItem: (params, api) => {
                            const index = api.value(0);
                            const yValue = api.value(1);
                            // ✅ 直接取接口返回的同比
                            const item = this.dataItem2.current[index]; // 当前月数据
                            let percent = item.importYoyChange || 0;  // 用接口的数据，不再计算
                            const last = zzx1[index];
                            const current = wgx1[index];



                            const displayText = (percent > 0 ? '+' : '') + percent + '%';
                            const [x, y] = api.coord([index, yValue]);

                            return {
                                type: 'group',
                                children: [
                                    {
                                        type: 'image',
                                        style: {
                                            image: require('@/assets/img/Group3898.png'),
                                            x: x - 20,
                                            y: y - 45,
                                            width: 50,
                                            height: 40
                                        }
                                    },
                                    {
                                        type: 'text',
                                        style: {
                                            text: displayText,
                                            x: x + 4,
                                            y: y - 32,
                                            textAlign: 'center',
                                            textVerticalAlign: 'middle',

                                            fill: '#5FC2F4',

                                            // stroke: 'rgba(255,255,255,0.3)',
                                            font: '400 13px YouSheBiaoTiHei',

                                            // stroke: '#fff',
                                            lineWidth: 1.5
                                        }
                                    }
                                ]
                            };
                        },


                        z: 100
                    }

                    // {
                    //     type: 'custom',
                    //     name: '',
                    //     data: zzx1.map((v, i) => ({
                    //         value: [i, Math.max(zzx1[i], wgx1[i]) + 8] // 只存坐标
                    //     })),

                    //     renderItem: (params, api) => {
                    //         const index = api.value(0);
                    //         const yValue = api.value(1);

                    //         const last = zzx1[index];
                    //         const current = wgx1[index];
                    //         console.log(api);

                    //         // 防止除以零
                    //         let percent = 0;
                    //         if (last !== 0) {
                    //             percent = Math.round((current - last) / last * 100);
                    //         }

                    //         const displayText = (percent > 0 ? '+' : '') + percent + '%';
                    //         const [x, y] = api.coord([index, yValue]);

                    //         return {
                    //             type: 'group',
                    //             children: [
                    //                 {
                    //                     type: 'image',
                    //                     style: {
                    //                         image: require('@/assets/img/Group3898.png'),
                    //                         x: x - 20,
                    //                         y: y - 30,
                    //                         width: 50,
                    //                         height: 40
                    //                     }
                    //                 },
                    //                 {
                    //                     type: 'text',
                    //                     style: {
                    //                         text: displayText,
                    //                         x: x + 4,
                    //                         y: y - 17,
                    //                         textAlign: 'center',
                    //                         textVerticalAlign: 'middle',

                    //                         fill: '#5FC2F4',

                    //                         stroke: 'rgba(255,255,255,0.3)',
                    //                         font: '400 13px YouSheBiaoTiHei',

                    //                         // stroke: '#fff',
                    //                         lineWidth: 1.5
                    //                     }
                    //                 }
                    //             ]
                    //         };
                    //     },


                    //     z: 100
                    // }
                ],
            };

            myChart.clear();
            myChart.setOption(option);
        }
    },
    created() { },
    async mounted() {
        await this.initData();

        // this.timer = setInterval(async () => {
        //     await this.drawLine();
        // }, this.intervalRefreshDate)

        // const { arr2025, arr2024 } = this.splitByYear(this.arrData);
        // console.log(arr2025, arr2024)

        // console.log(this.filterLast12Months(this.arrData), 222)



    },
    beforeDestroy() {
        console.log("销毁定时器")
        //2.销毁前清除定时器
        clearInterval(this.timer);
    },
}
</script>
<style lang="scss" scoped></style>